import { Link } from "react-router-dom";
import { ShieldCheck, BatteryCharging, FileCheck2 } from "lucide-react";
import { formatPrice } from "@/data/products";
import { ProductWhatsAppButton } from "@/components/whatsapp/WhatsAppButton";
import { motion } from "framer-motion";

export const ProductCard = ({ product }) => {
  const u = product.used;
  return (
    <motion.article
      variants={{ hidden: { opacity: 0, y: 24 }, show: { opacity: 1, y: 0, transition: { duration: 0.6, ease: [0.22, 1, 0.36, 1] } } }}
      className="group flex flex-col overflow-hidden rounded-2xl border border-border bg-card"
      data-testid={`product-card-${product.slug}`}
    >
      <Link to={`/phones/${product.slug}`} className="relative block overflow-hidden bg-[hsl(var(--paper))]">
        <div className="absolute left-3 top-3 z-10 flex gap-2">
          <span className="chip bg-white/90 backdrop-blur">{product.type === "new" ? "New" : "Pre-Owned"}</span>
        </div>
        <img
          src={product.image}
          alt={`${product.brandName} ${product.model} in ${product.color}`}
          loading="lazy"
          className="mx-auto aspect-square w-full max-w-[280px] object-contain p-6 transition-transform duration-500 group-hover:scale-105"
        />
      </Link>

      <div className="flex flex-1 flex-col p-5">
        <p className="text-xs font-semibold uppercase tracking-widest text-[hsl(var(--ink-soft))]">{product.brandName}</p>
        <Link to={`/phones/${product.slug}`}>
          <h3 className="mt-1 text-lg font-semibold leading-tight hover:accent-text">{product.model}</h3>
        </Link>
        <p className="mt-0.5 text-sm text-[hsl(var(--ink-soft))]">{product.storage} · {product.color}</p>

        {u && (
          <div className="mt-3 flex flex-wrap gap-1.5">
            <span className="chip"><ShieldCheck className="h-3 w-3" /> {u.condition}</span>
            <span className="chip"><BatteryCharging className="h-3 w-3" /> {u.batteryHealth}%</span>
            {u.warrantyMonths ? <span className="chip">{u.warrantyMonths}mo warranty</span> : null}
            {u.billAvailable ? <span className="chip"><FileCheck2 className="h-3 w-3" /> Bill</span> : null}
          </div>
        )}

        <div className="mt-4 flex items-end justify-between">
          <p className="text-xl font-semibold">{formatPrice(product.price)}</p>
          <span className="text-xs text-[hsl(var(--ink-soft))]">{product.availability}</span>
        </div>

        <div className="mt-4 flex flex-col gap-2">
          <Link to={`/phones/${product.slug}`} className="btn-outline w-full" data-testid={`view-details-${product.slug}`}>
            View Details
          </Link>
          <ProductWhatsAppButton product={product} full />
        </div>
      </div>
    </motion.article>
  );
};
